import React, {useEffect, useState} from "react";
import {BoxIsolatedContent, FlexColumnCentered, FormGoBack} from "../../../components/ui/Content";
import {ButtonPrimary} from "../../../components/ui/Button";

import {FormTitle, RecoveryEmailInfo} from "../../../components/Font";
import {GoBack} from "../../../icon/Icon";
import {useTranslation} from "react-i18next";
import {InputElement} from "../../../ui/Input/Input";
import {cleanError, RecoverySendCode, setRecoveryData} from "../slice";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {RecoveryInputContainer, RegisterInputContainer} from "../../../components/ui/InputSearch";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../ui/Loader/MiniLoader";
import {useTheme} from "styled-components";
import {useLocation, useNavigate} from "react-router-dom";

export const PasswordRecovery = () => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const {search} = useLocation()
    const Theme = useTheme()
    const [phone, setPhone] = useState('')
    const {error, isFetching} = useAppSelector(state => state.auth)
    const userLogin = localStorage.getItem('userLogin') ? localStorage.getItem('userLogin') : phone;

    useEffect(() => {
        setPhone(userLogin ?? '');
    }, [userLogin]);

    return <FlexColumnCentered className={'box-isolated'}>
        <BoxIsolatedContent>
            <FlexColumnCentered style={{width: '100%'}}>
                <FormGoBack onClick={() => {
                    dispatch(setRecoveryData(null))
                    navigate(`/sign-in${search}`)
                }}>
                    <GoBack/>
                </FormGoBack>
                <FormTitle>{t('auth.passwordRecovery')}</FormTitle>
                <RecoveryEmailInfo style={{textAlign: 'center', width: '270px'}}>
                    {t('auth.enterPhoneForRecovery')}
                </RecoveryEmailInfo>
            </FlexColumnCentered>
            <RegisterInputContainer>
                <RecoveryInputContainer>
                    <InputElement
                        autofocus={true}
                        value={phone}
                        onChange={value => {
                            if (error['phone']) {
                                dispatch(cleanError('phone'))
                            }
                            setPhone(value)
                        }}
                        placeholder={t('auth.phoneTitle')}
                        error={error['phone']}
                        onKeyDown={(key) => {
                            if (key === 'Enter' && phone.length >= 1) {
                                dispatch(RecoverySendCode(phone))
                                localStorage.removeItem('userLogin')
                            }
                        }}
                    />
                </RecoveryInputContainer>
            </RegisterInputContainer>
            {isFetching
                ? <ButtonPrimary style={{
                    width: '100%',
                    marginTop: '24px'
                }}>
                    <LoaderContainer>
                        <MiniLoader color={Theme.color.primaryBackground} size={LoaderEnum.small}/>
                    </LoaderContainer>
                </ButtonPrimary>
                : <ButtonPrimary
                    disabled={phone.length < 1}
                    onClick={() => {
                        dispatch(RecoverySendCode(phone))
                    }}
                    style={{
                        width: '100%',
                        marginTop: '24px'
                    }}>
                    {t('auth.continue')}
                </ButtonPrimary>}
        </BoxIsolatedContent>
    </FlexColumnCentered>
}
